import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import TitleTextBox from '@/component/TitleTextBox';
import Pagenation from '@/component/Pagenation';
import SearchBtn from '@/component/SearchBtn';

interface ModalType1Props {
  children: ReactNode;
  width?: number;
}

const ModalType1 = ({ children, width }: ModalType1Props) => {
  return (
    <>
      <CS.ModalBg>
        <CS.ModalType1 style={{ width: width }}>{children}</CS.ModalType1>
      </CS.ModalBg>
    </>
  );
};

export default ModalType1;
